// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"1d57766c","451":"0fa80c0a","895":"218f2681"}[chunkId] + ".chunk.css";
};